import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Row, ContainerCol } from '../componentes_formulario/contenedores';
import ModalResponsive from '../componentes_formulario/modals/modalresponsive';
// import ReactSelect from '../componentes_formulario/selects/react-select';
import {LabelForm,LabelNota} from '../componentes_formulario/labels/';
import AgGridRender from '../grid/ag_grid_render';
import { bindActionCreators } from 'redux';
import { formatearNumeroDecimal } from '../../../funciones_globales/format';
import global_axios  from '../../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../../actions/generales/act_gen01';
import { InputText } from '../componentes_formulario/inputs/inputtext';


const ModalContainer = styled.div`
    margin-top: 20px;
    height: 400px;
    width: 900px;
`;

const PaginationLabels = styled.div`
    font-size: 12px;
`;

const PaginationButtons = styled.div`
    margin-bottom:10px;
`;
const LabelTotales = styled.label`
	display: inline-block;
	font-size: 10px;
	color: green;
`;
const LabelValorTotales = styled.label`
	display: inline-block;
	font-size: 9px;
	font-weight: bold;
	align-text: right;
`;
const LabelValor = styled.label`
  display: inline-block;
  font-size: 10px;
  color: green;
  margin-left: 5px;
  font-weight: bold;
  margin-top: 3px;
`;
//Styles
const tableR= {
  maxHeight: '300px',
  maxWidth:'780px',
  margin: '10px',
  overflow: 'auto',
}

//props principales : usuario, tipo
class ComponenteAprobacion extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            observacionAprobador:'',
            tamano_observacion:290,
            mensaje: '',
            usuarioSolicitante:null,
            solicitudDetalle:null,
            detalleSolicitudData:[],//para tabla de detalle
            totalItems:0,
            totalValor:0,
            bodegaDestino:null,
            bodegaOrigen:null,
            observacion:'',
            interval:null,
            mensajes:[],
            tipoSolicitudDetalle:null,
            isModalDetalleVisible:false,
            pagination: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            colDetalleSolicitud:[
                {   header: "No.",
                    field: "Consecutivo",
                    width: 50,
                    type: "string"
                },
                {   header: "Cod.Artículo",
                    field: "Articulo",
                    width: 100,
                    type: "string"
                },
                {   header: "Articulo",
                    field: "Nombre",
                    width: 100,
                    type: "string"
                },
                {   header: "Cantidad",
                    field: "Cantidad",
                    width: 80,
                    type: "num_entero"
                },                          
                {   header: "Costo Promedio",
                    field: "CostoPromedio",
                    width: 100,
                    type: "num_decimal"                                 
                },
                {   header: "Total",
                    field: "Total",
                    width: 100,
                    type: "num_decimal"                                 
                },
            ],
        };
        this.gridDetalleOptions = {
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,
            onRowDoubleClicked: event => {
               
			},
            onPaginationChanged: () => {
                if(!this.apiDetalle){
                    return;
                }
                let totalFilas = this.apiDetalle.paginationGetRowCount();
                let totalFilasPorPagina = this.apiDetalle.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.apiDetalle.paginationGetCurrentPage()+1));
                let indexPage = this.apiDetalle.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
           
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({pagination});
			},
        };
        this.handleInputChange = this.handleInputChange.bind(this)
        this.onGridDetalleReady= this.onGridDetalleReady.bind(this);
    }
 
    handleInputChange(event){    
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [name]: value
        });

    }
      
         
 
    aprobar(index){

        //Ingresamos un mensaje a mostrar
        console.log(this.props.socket)
        let observacion= this.state.observacionAprobador;
        //Detectamos si el usuario ingreso un valor
                if(observacion.length<=this.state.tamano_observacion){
                    //Se recupera la solicitud que se desea aprobar
                    let solicitud= this.props.solicitudes[index]
                    var query = "?TransaccionNumber="+solicitud.TransaccionId+"&Tipo="+ solicitud.Tipo+"& ="+observacion+"&Usuario="+this.props.usuario.UsuarioId;
                    var data={
                        para:solicitud.desde,
                        desde:this.props.usuario.NombreUsuario,
                        desde_socket: solicitud.para,
                        desde_username:this.props.usuario.Login,
                        transaccion_id:solicitud.TransaccionId,
                        mensaje:"Transacción Aprobada",
                        observacion:observacion,
                        tipo:solicitud.Tipo,
                        procesada:true,
                        aprueba:true,
                    };
                    this.props.cambiar_VisualizacionLoading(true)
                    global_axios({
                        method: 'GET',
                        url: '/aprobaciontransaccion/aprobacion'+query
                    }).then((response)=>{ 
                        console.log("EN RESPONSE")
                        console.log(response)
                        this.props.cambiar_VisualizacionLoading(false)
                        this.setState({observacionAprobador:''},()=>{
                            alert('La Solicitud se aprobo con exito.')
                            //Envio de mensaje de confirmacion de aprobacion al solicitante.
                            this.props.socket.emit("confirmacion",data);
                        })
                    
                    }).catch((error)=>{
                        console.log("CATCH")
                        console.log(error)
                        this.setState({observacionAprobador:''},()=>{
                            alert(error.response?error.response.data.msg:error.message);
                            this.props.cambiar_VisualizacionLoading(false)
                        })
                    })
                }else{
                    alert('Ingrese una observación mas corta, se permite un maximo de 280 caracteres.')
                }
            
 
    }
    negar(index){
        //Ingresamos un mensaje a mostrar
        let observacion= this.state.observacionAprobador;
       
            if(observacion.length<=this.state.tamano_observacion){
                //Se recupera la solicitud que se desea aprobar
                let solicitud= this.props.solicitudes[index]
                let query = "?TransaccionNumber="+solicitud.TransaccionId+"&Tipo="+ solicitud.Tipo+"&Observacion="+observacion+"&Usuario="+this.props.usuario.UsuarioId;
                var data={
                    para:solicitud.desde,
                    desde:this.props.usuario.NombreUsuario,
                    desde_socket: solicitud.para,
                    desde_username:this.props.usuario.Login,
                    transaccion_id:solicitud.TransaccionId,
                    mensaje:"Transacción Negada:",
                    observacion:observacion,
                    tipo:solicitud.Tipo,
                    procesada:true,
                    aprueba:false
                }
                this.props.cambiar_VisualizacionLoading(true)
                global_axios({
                    method: 'GET',
                    url: '/aprobaciontransaccion/rechazo'+query
                }).then((response)=>{ 
                  this.props.cambiar_VisualizacionLoading(false)
                  this.setState({observacionAprobador:''},()=>{
                    alert('La Solicitud se rechazo con exito.')
                    //Envio de mensaje de confirmacion de aprobacion al solicitante.
                    this.props.socket.emit("confirmacion",data);
                  })
                  
              }).catch((error)=>{
                this.setState({observacionAprobador:''},()=>{
                    alert(error.response?error.response.data.msg:error.message);
                    this.props.cambiar_VisualizacionLoading(false)
                })
              })
            }else{
                alert('Ingrese una observación mas corta, se permite un maximo de 280 caracteres.')
            }
        
    }
    verDetalle(index){
        let solicitudDetalle= this.props.solicitudes[index];
        //Se procede a obtener el detalle
        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'GET',
            url: '/aprobaciontransaccion/detalle/' + solicitudDetalle.TransaccionId +'/'+ solicitudDetalle.Tipo
        })
        .then((response) => {
            let totalItems=response.data.TotalRegistros;
            let totalValor=response.data.TotalValores; 
            let observacion = response.data.Motivo;
            let tipo= response.data.Tipo;
            let bodegaDestino = response.data.comprobanteInventario.BodegaDestinoDescripcion+' ('+response.data.comprobanteInventario.BodegaDestino+')';
            let bodegaOrigen = response.data.comprobanteInventario.BodegaOrigenDescripcion+' ('+response.data.comprobanteInventario.BodegaOrigen+')';
            let detComprobanteInventario= response.data.comprobanteInventario.detComprobanteInventario;
            this.setState({detalleSolicitudData:detComprobanteInventario, totalValor,totalItems,observacion,bodegaDestino,bodegaOrigen,solicitudDetalle,isModalDetalleVisible:true,tipoSolicitudDetalle:tipo})
            this.props.cambiar_VisualizacionLoading(false);
        })
        .catch( (error) => {
        	this.props.cambiar_VisualizacionLoading(false);				
			alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);
        });
    }
    
    onGridDetalleReady(params) {
		this.apiDetalle = params.api;
		this.gridApiColumnaDetalle = params.columnApi;
    }
    render(){
        return(
            <div>
                <ModalResponsive open={this.props.visible} onClose={this.props.onClose}>
        
                    <ModalContainer>
                        <Row>
                            <ContainerCol className='col-sm-12'>
                                <h4>{this.props.title}</h4>
                              
                            </ContainerCol>
                        </Row>
                        {/* <Row>
                            <ContainerCol className='col-sm-6' margen_arriba='15' margen_abajo='4'>
                                <LabelForm>Solicitantes Conectados:</LabelForm>
                                <ReactSelect options={ this.props.usuariosSolicitantes } value={this.state.usuarioSolicitante} func_onChange={(value)=>{this.setState({usuarioSolicitante: value!==null?value:null})}}/>
                            </ContainerCol>
                        </Row> */}
                      
                
                            <Row>
                                <div style={tableR}>
                                    <div className="table-responsive">
                                        <table  className="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Fecha</th>
                                                        <th scope="col">Hora</th>
                                                        <th scope="col">Usuario</th>
                                                        <th scope="col">Tipo</th>
                                                        <th scope="col">Tot.Items</th>
                                                        <th scope="col">Tot.Valor</th>
                                                        <th scope="col">Detalle</th>
                                                        <th scope="col">Aprobar</th>
                                                        <th scope="col">Rechazar</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {   
                                                        this.props.solicitudes.map((solicitud, i) => { 
                                                            return (
                                                            <tr key={i}>
                                                                <td> 
                                                                    {solicitud.Fecha}
                                                                </td>
                                                                <td> 
                                                                    {solicitud.Hora}
                                                                </td>
                                                                <td > 
                                                                    {solicitud.UsuarioSolicitante}
                                                                </td>
                                                                <td >
                                                                    {solicitud.TipoMostrar}
                                                                </td>
                                                                <td >
                                                                    {solicitud.Total_item}
                                                                </td>
                                                                <td >
                                                                    {solicitud.Total_valor}
                                                                </td>
                                                                <td >
                                                                    <button  onClick={this.verDetalle.bind(this,i)} type="Button" className="btn btn-primary" ><i className="fa fa-eye" aria-hidden="true"></i></button>
                                                                </td>
                                                                <td >
                                                                    <button  onClick={this.aprobar.bind(this,i)} type="Button" className="btn btn-success" ><i className="fa fa-check" aria-hidden="true"></i></button>
                                                                </td>
                                                                <td >
                                                                    <button  onClick={this.negar.bind(this,i)} type="Button"  className="btn btn-danger"><i className="fa fa-ban" aria-hidden="true"></i> </button>
                                                                </td>
                                                            
                                                            </tr>)
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>  
                                </Row>   
                                <Row>
                                {
                                    (this.props.solicitudes.length>0)? 
                                    <ContainerCol className='col-sm-10'>
                                        <LabelForm>Observación de Aprobación o Rechazo:</LabelForm>
                                        <InputText   name='observacionAprobador' value={this.state.observacionAprobador} onChange={this.handleInputChange} type="text" className='form-control input-sm'/>            
                                        <LabelForm><span><h5>El campo Observación no es requerido, pero se recomienda ingresar una.</h5></span></LabelForm>
                                    </ContainerCol>   
                                    :
                                    null
                                }
                                    
                                </Row>
                                     
                    </ModalContainer>
                </ModalResponsive>
                <ModalResponsive  open={this.state.isModalDetalleVisible} onClose={() => this.setState({isModalDetalleVisible:false})}>
					<ModalContainer>
						<Row>
							<ContainerCol className='col-xs-8 col-sm-8' align="center">
								<h4><strong>Detalle {(this.state.solicitudDetalle!==null?this.state.solicitudDetalle.TipoMostrar:'')}</strong></h4>
							</ContainerCol>
						</Row>
                        {
                            (this.state.tipoSolicitudDetalle==='TRF')?
                            <Row>
                                <ContainerCol className='col-sm-6'>
                                    <LabelForm>Bodega Origen:</LabelForm>
                                    <LabelValor>{this.state.bodegaOrigen}</LabelValor>
                                </ContainerCol>
                                <ContainerCol className='col-sm-6'>
                                    <LabelForm>Bodega Destino:</LabelForm>
                                    <LabelValor>{this.state.bodegaDestino}</LabelValor>
                                </ContainerCol>    
                            </Row>
                            :
                            <Row>
                                <ContainerCol className='col-sm-6'>
                                    <LabelForm>Bodega</LabelForm>
                                    <LabelValor>{this.state.bodegaOrigen}</LabelValor>
                                </ContainerCol>
                            </Row>
                        }
                        <Row>
                            <ContainerCol className='col-sm-12'>
                                <LabelForm>Motivo/Observación:</LabelForm>
                                <LabelForm>{'  '+this.state.observacion}</LabelForm>
                            </ContainerCol>   
                        </Row>

						<Row>
							<ContainerCol className="col-xs-12 col-sm-12">
								<Row>
									<ContainerCol className="col-xs-8 col-sm-8">
										<AgGridRender
											altura='150px'
											data={this.state.detalleSolicitudData}
											columnas={this.state.colDetalleSolicitud}
											onGridReady={this.onGridDetalleReady}
                                            gridOptions={this.gridDetalleOptions}
                                            alturaRow={20}
										/>
									</ContainerCol>
								</Row>
                                <Row>
                                    <div className="col-xs-8 col-sm-8">
                                        <Row>
                                            <ContainerCol className="col-xs-12 col-sm-12">
                                                <PaginationLabels>
                                                    {this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                                                </PaginationLabels>
                                                <ContainerCol className="xol-xs-2 col-sm-2 pull-right">
                                                    <LabelTotales>Total: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalValor)}</LabelValorTotales>
                                                </ContainerCol>
                                                <PaginationButtons>
                                                    <div className="btn-group btn-group-xs" role="group">
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalle.paginationGoToFirstPage()}>
                                                            <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalle.paginationGoToPreviousPage()}>
                                                            <i className="fa fa-angle-left fa-fw"></i>Anterior
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalle.paginationGoToNextPage()}>
                                                            Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalle.paginationGoToLastPage()}>
                                                            Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                                        </button>
                                                    </div>
                                                </PaginationButtons>
                                            </ContainerCol>
                                        </Row>
                                    </div>

                                    <div className="col-sm-12">
                                        <Row>
                                        <ContainerCol className="col-xs-12 col-sm-12">
                                            <div className="col-xs-5 col-sm-5">
                                                <LabelNota>{'Click derecho para exportar la tabla a excel'}</LabelNota>
                                            </div> 
                                        </ContainerCol>
                                        </Row>
                                    </div>
                                </Row>
							</ContainerCol>
						</Row>
					</ModalContainer>
				</ModalResponsive>
            </div>
        );
    }
}

const mapStateToProps = ((state) => {
    return {
    };
});
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ cambiar_VisualizacionLoading}, dispatch)
    });
  
export default connect (mapStateToProps,mapDispatchToProps)(ComponenteAprobacion);